import { useState, useCallback } from 'react';

const KYC_CERTIFIED_ONLY_COND_KEYS: { [key: string] : string } = {
  TRUE: '提出済み'
}

const AREA_COND_KEYS: { [key: string] : string } = {
  HOKKAIDO: '北海道',
  TOHOKU: '東北',
  KANTO: '関東',
  CHUBU: '中部',
  KINKI: '近畿',
  CHUGOKU: '中国',
  SHIKOKU: '四国',
  KYUSHU: '九州'
}

const AGE_COND_KEYS: { [key: string] : string } = {
 20: '20代',
 30: '30代',
 40: '40代',
 50: '50代以上'
}

const BLOOD_TYPE_COND_KEYS: { [key: string] : string } = {
  A: 'A型',
  B: 'B型',
  O: 'O型',
  AB: 'AB型'
}

const HEIGHT_COND_KEYS: { [key: string] : string } = {
  150: '〜160cm',
  160: '160cm〜170cm',
  170: '170cm〜180cm',
  180: '180cm〜'
}

const BODY_FIGURE_COND_KEYS: { [key: string] : string } = {
  SKINNY: '痩せている',
  THIN: '細め',
  NORMAL: '普通',
  THICK: 'がっちり',
  FAT: '太め'
}

const COLLEGE_TYPE_COND_KEYS: { [key: string] : string } = {
  PUBLIC: '国公立大学',
  PRIVATE: '私立大学',
  HIGHSCHOOL: '高等学校'
}

const MAJOR_TYPE_COND_KEYS: { [key: string] : string } = {
  BS: '理系',
  BA: '文系',
  OTHER: 'その他'
}

const MARRIAGE_CON_KEYS: { [key: string] : string } = {
  UNMARRIED: '未婚',
  MARRIED: '既婚',
  DIVORCED: '離婚'
}

const NATIONALITY_COND_KEYS: { [key: string] : string } = {
  JAPANESE: '日本',
  OTHER: '日本以外'
}

const RACE_COND_KEYS: { [key: string] : string } = {
  JAPANESE: '日本人',
  EAST_ASIAN: '東アジア',
  OTHER_ASIAN: '他のアジア',
  CAUCASIAN: '白人系',
  AFRICAN: 'アフリカ系',
  HISPANIC: 'ヒスパニック系',
  MIXED: '混血',
  OTHER: 'その他'
}

const HAIR_TYPE_COND_KEYS: { [key: string] : string } = {
  STRAIGHT: '直毛',
  WAVY: 'クセ毛',
  SOFT: '軟毛',
  HARD: '硬毛',
  COARSE: '剛毛'
}

const HAIR_COLOR_COND_KEYS: { [key: string] : string } = {
  BLACK: '黒色',
  DARK_BROWN: '濃い茶色',
  LIGHT_BROWN: '薄い茶色',
  OTHER: 'その他'
}

const EYELID_COND_KEYS: { [key: string] : string } = {
  SINGLE: '一重',
  HOODED: '奥二重',
  DOUBLE: '二重'
}

const TRAVEL_EXPENSES_COND_KEYS: { [key: string] : string } = {
  DONOR_PAYS: 'ドナー負担',
  DONEE_PAYS: 'ドニー負担',
  SPLIT: '割り勘'
}

const IDENTITY_DISCLOSURE_COND_KEYS: { [key: string] : string } = {
  AVAILABLE: '可',
  UNAVAILABLE: '不可（匿名）'
}

const CERTIFICATE_PRESENTATION_COND_KEYS: { [key: string] : string } = {
  AVAILABLE: '可',
  UNAVAILABLE: '不可'
}

const ORIGIN_RIGHT_COND_KEYS: { [key: string] : string } = {
  AVAILABLE: '対応可',
  UNAVAILABLE: '対応不可'
}

const CHILDREN_COND_KEYS: { [key: string] : string } = {
  TRUE: 'いる',
  FALSE: 'いない'
}

const STD_CERTIFIED_ONLY_COND_KEYS: { [key: string] : string } = {
  TRUE: '検査済み'
}

const SEMEN_TOTAL_COND_KEYS: { [key: string] : string } = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E'
}

const METHODS_COND_KEYS: { [key: string] : string } = {
  SYRINGE: 'シリンジ法',
  TIMING: 'タイミング法'
}

const GRATUITY_COND_KEYS: { [key: string] : string } = {
  0: 'なし',
  5000: '〜5,000円',
  10000: '〜10,000円'
}

const REVIEW_SCORE_COND_KEYS: { [key: string] : string } = {
  '5': '★5',
  '4': '★4以上',
  '3': '★3以上'
}

export const COND_KEY_SET = {
  kyc_certified_only: KYC_CERTIFIED_ONLY_COND_KEYS,
  area: AREA_COND_KEYS,
  age: AGE_COND_KEYS,
  blood_type: BLOOD_TYPE_COND_KEYS,
  height: HEIGHT_COND_KEYS,
  body_figure: BODY_FIGURE_COND_KEYS,
  college_type: COLLEGE_TYPE_COND_KEYS,
  major_type: MAJOR_TYPE_COND_KEYS,
  marriage: MARRIAGE_CON_KEYS,
  children: CHILDREN_COND_KEYS,
  std_certified_only: STD_CERTIFIED_ONLY_COND_KEYS,
  semen_total: SEMEN_TOTAL_COND_KEYS,
  methods: METHODS_COND_KEYS,
  gratuity: GRATUITY_COND_KEYS,
  review_score: REVIEW_SCORE_COND_KEYS,
  nationality: NATIONALITY_COND_KEYS,
  race: RACE_COND_KEYS,
  hair_type: HAIR_TYPE_COND_KEYS,
  hair_color: HAIR_COLOR_COND_KEYS,
  eyelid: EYELID_COND_KEYS,
  travel_expenses: TRAVEL_EXPENSES_COND_KEYS,
  identity_disclosure: IDENTITY_DISCLOSURE_COND_KEYS,
  certificate_presentation: CERTIFICATE_PRESENTATION_COND_KEYS,
  origin_right: ORIGIN_RIGHT_COND_KEYS
}

export type CondKey = 'kyc_certified_only' | 'area' | 'age' | 'blood_type' | 'height' | 'body_figure' |
                'college_type' | 'major_type' | 'marriage' | 'children' |
                'std_certified_only' | 'semen_total' | 'methods' | 'gratuity' | 'review_score' |
                'nationality' | 'race' | 'hair_type' | 'hair_color' | 'eyelid' |
                'travel_expenses' | 'identity_disclosure' | 'certificate_presentation' | 'origin_right';

export const useSearchConds = () => {
  const [ conds, setConds ] = useState<{ [key: string]: string[] }>({});

  const resetConds = useCallback((searchParams?: URLSearchParams) => {
    const newConds: { [key: string]: string[] } = {};

    if (!searchParams) { return setConds({}) };

    for (const k of searchParams.keys()) {
      newConds[k.replaceAll("[]","")] = searchParams.getAll(k);
    }
    setConds(newConds);
  }, [])

  const setCond = useCallback((condKey: string, key: string, add = true) => {
    let condValues: string[] = conds[condKey] || [];

    if (add) {
      condValues.push(key);
    } else {
      condValues = condValues.filter(v => v !== key);
    }

    setConds(state => {
      return {
        ...state,
        [condKey]: condValues
      }
    });
  }, [ conds ]);

  const stringifyParams = useCallback(() => {
    const params = new URLSearchParams();
    Object.keys(conds).forEach(k => {
      const key = `${ k }[]`;
      conds[k].forEach(v => {
        params.append(key, v);
      });
    });
    return params.toString();
  }, [ conds ]);

  return { conds, setCond, resetConds, stringifyParams };
}
